var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeedback = function SvgFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#feedback_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.711 16.176c1.158.043 2.58.074 4.289.074 3.071 0 5.219-.1 6.563-.193 1.063-.074 1.892-.867 1.985-1.928.102-1.162.202-2.927.202-5.379s-.1-4.217-.203-5.38c-.092-1.06-.921-1.853-1.984-1.927C15.22 1.349 13.072 1.25 10 1.25s-5.219.1-6.563.193c-1.063.074-1.892.867-1.984 1.928C1.35 4.533 1.25 6.298 1.25 8.75v9.438a.833.833 0 0 0 1.376.633z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5a5 5 0 0 0 4.93-4.17c.077-.454-.303-.83-.764-.83H5.833c-.46 0-.84.376-.765.83A5 5 0 0 0 10 12.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "feedback_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgFeedback;